<template>
  <div>
    <div class="hidden md:block">
      <Button
        text="Check Availability"
        icon="fa-regular fa-calendar-check"
        class="sera-btn"
        @click="toggleOpen"
      />
    </div>
    <button
      type="button"
      class="w-[40px] h-[40px] md:hidden text-primary-700 bg-white border border-primary-700 hover:bg-blue-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-lg p-2 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      @click="toggleOpen"
    >
      <CalendarIcon height="24" width="24" />
    </button>
    <modal v-if="open" title="Check Availability" @hide-modal="toggleOpen">
      <div class="form-container">
        <text-field
          v-model="formData.zip_code"
          label="Zip Code"
          class="full-width"
          name="Zip Code"
          :validation-errors="v$.$errors"
        ></text-field>
        <divider></divider>
        <service-category-form
          v-model="formData.service_category_id"
          :required="false"
        ></service-category-form>
        <divider></divider>
        <eligible-technicians-form
          v-model="formData.user_id"
          :service-category-id="formData.service_category_id"
          no-save
        ></eligible-technicians-form>
        <divider></divider>
        <availability-form
          v-if="formData.service_category_id"
          v-model="formData.scheduled_time"
          :service-category-id="formData.service_category_id"
          :technician-id="primaryTechId"
          :technician-ids="multiTechUserIds"
          :postal-code="formData.zip_code"
          :current-scheduled-time="formData.scheduled_time"
        ></availability-form>
        <div v-else>
          <b>Scheduled:</b>
          <span class="hint-text"
            >Select a Service Category to View Availability</span
          >
        </div>
      </div>
      <template #footer>
        <div></div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Button from "@/components/Button.vue";
import Divider from "@/components/Divider.vue";
import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";
import AvailabilityForm from "@/EditAppointmentModal/forms/AvailabilityForm.vue";
import EligibleTechniciansForm from "@/EditAppointmentModal/forms/EligibleTechniciansForm.vue";
import ServiceCategoryForm from "@/EditAppointmentModal/forms/ServiceCategoryForm.vue";
import CalendarIcon from "@/images/CalendarDots.svg?component";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
const { withAsync } = helpers;

export default {
  components: {
    Button,
    Modal,
    Divider,
    EligibleTechniciansForm,
    AvailabilityForm,
    ServiceCategoryForm,
    TextField,
    CalendarIcon
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      formData: {
        service_category_id: null,
        scheduled_time: "",
        user_id: null
      },
      open: false
    };
  },
  computed: {
    isMultiTechEnabled() {
      return !!this.$store.state.tenant?.feature_flags
        ?.multiple_technicians_ff_enabled;
    },
    primaryTechId() {
      const uid = this.formData.user_id;
      if (Array.isArray(uid)) return uid[0] ?? null;
      return uid;
    },
    multiTechUserIds() {
      if (!this.isMultiTechEnabled) return undefined;
      const uid = this.formData.user_id;
      if (Array.isArray(uid)) return uid;
      if (uid != null) return [uid];
      return undefined;
    }
  },
  validations() {
    const currentAdminEmail = window.currentTenant.user_email;

    const validateCoverageArea = (value) => {
      return new Promise((resolve) => {
        if (value.length > 4) {
          this.validateCoverageArea({
            email: currentAdminEmail,
            zip_code: value
          })
            .then(() => resolve({ valid: true }))
            .catch(() => resolve({ valid: false }));
        } else {
          resolve({ valid: true });
        }
      });
    };

    return {
      formData: {
        zip_code: {
          coverageAreaValidation: helpers.withMessage(
            "Zip code is not in your coverage area!",
            withAsync(validateCoverageArea)
          ),
          $autoDirty: true
        }
      }
    };
  },
  watch: {
    open(newValue) {
      if (!newValue) {
        // Reset form on modal close
        this.resetForm();
      }
    }
  },
  methods: {
    ...mapActions(["validateCoverageArea"]),
    resetForm() {
      this.formData = {
        service_category_id: null,
        scheduled_time: "",
        user_id: null
      };
    },
    toggleOpen() {
      this.open = !this.open;
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.label) {
  font-weight: bold;
}
</style>
